<div class="output-card-container">
  <img
    height="80"
    width="80"
    [src]="iconPath"
  />
  <div class="text-container">
    <div class="output-card-label">{{ label }}</div>
    <div class="output-card-value">{{ text }}</div>
  </div>
</div>
